export function getEhsCode(vehicle) {
    let code = '';

    const type = vehicle.type.key;
    if (type == 'phev-comfort-fr') {
        code = 'MFSUSC1H5DL';
        if (vehicle.color.key == 'pearl-white') code = 'MFSUSC3H5DL';
    }

    if (type == 'phev-luxury-fr') {
        code = 'MFSUSGBH5DL';
        if (vehicle.color.key == 'pearl-white') code = 'MFSUSGDH5DL';
        if (vehicle.options && vehicle.options['brown-interior'].selected) {
            code = 'MFSUSGBH5DS';
            if (vehicle.color.key == 'pearl-white') code = 'MFSUSGDH5DS';
        }
    }

    return code;
}

export function getEhsHybridPlusCode(vehicle) {
    let code = '';

    const ehsType = vehicle.type.key;

    if (ehsType == 'comfort') {
        code = 'MFSYSC1H5DL';
        if (vehicle.color.key == 'pearl-white') code = 'MFSYSC2H5DL';
    }

    if (ehsType == 'luxury') {
        code = 'MFSYSG3H5DL';
        if (vehicle.color.key == 'pearl-white') code = 'MFSYSG4H5DL';
        if (vehicle.options && vehicle.options['brown-interior'].selected) {
            code = 'MFSYSG3H5DS';
            if (vehicle.color.key == 'pearl-white') code = 'MFSYSG4H5DS';
        }
    }

    return code;
}

export function getMarvelRCode(vehicle) {
    let code = '';

    //check for comfort, luxury and performance type
    const marvelRType = vehicle.type.key;

    if (marvelRType == 'comfort') code = 'MGP3SD19DCL'; //default black interior;
    if (marvelRType == 'luxury') {
        if (vehicle.options.greyInterior.selected)
            code = 'MGP3SD59DCD'; //with grey interior
        else code = 'MGP3SD39DCL'; //with black interior
    }
    if (marvelRType == 'performance') {
        if (vehicle.options.greyInterior.selected) code = 'MGP3SG49ECD';
        else code = 'MGP3SG29ECL';
    }
    return code;
}

export function getZsEvCode(vehicle) {
    let code = '';

    const zsEvType = vehicle.type.key;
    if (zsEvType == 'comfort') {
        const versionKey = vehicle.version.key;
        if (versionKey == 'standard-range') code = 'MDPCSC19KC';
        if (versionKey == 'long-range') code = 'MDPCSC39KC';
    }
    if (zsEvType == 'luxury') {
        const versionKey = vehicle.version.key;
        if (versionKey == 'standard-range') code = 'MDPCSD39KC';
        if (versionKey == 'long-range') code = 'MDPCSD99KC';
    }

    return code + 'C';
}

export function getZsCode(vehicle) {
    let code = '';

    const zsType = vehicle.type.key;
    if (zsType == 'comfort') code = 'MDPESC2BK1';
    if (zsType == 'luxury') {
        const versionKey = vehicle.version.key;
        if (versionKey == 'comfort-engine-5') code = 'MDPESD2BK1';
        if (versionKey == 'comfort-engine-6') code = 'MDPESD2B14';
    }

    return code + 'C';
}

export function getMg5Code(vehicle) {
    let code = '';

    const mg5Type = vehicle.type.key;
    const versionKey = vehicle.version.key;
    if (mg5Type == 'comfort') {
        if (versionKey == 'standard-range') code = 'MGP2TC19LCL'; // + black interior
        if (versionKey == 'extended-range') code = 'MGP2TC59LCL'; // + black interior
    }
    if (mg5Type == 'luxury') {
        if (versionKey == 'standard-range') {
            if (vehicle.options.greyInterior.selected)
                code = 'MGP2TD19LCC'; // + grey interior
            else code = 'MGP2TD19LCL';
        }

        if (versionKey == 'extended-range') {
            if (vehicle.options.greyInterior.selected)
                code = 'MGP2TD49LCC'; // + grey interior
            else code = 'MGP2TD49LCL';
        }
    }

    return code;
}

export function getMg4Code(vehicle) {
    let code = '';

    const mg4Type = vehicle.type.key;
    const colorCode = vehicle.color.productCode;

    if (mg4Type == 'luxury') code = 'MGR4FD29RCL';
    if (mg4Type == 'standard') code = 'MGR4FT19RCL';
    if (mg4Type == 'xpower') {
        if (colorCode == 'GWH')
            code = 'MGR4FG19SCL'; // GWH - Hunter Green color
        else code = 'MGR4FG39SCL';
    }

    return code;
}

export function getMg4Mce2026Code(vehicle) {
    let code = '';

    const type = vehicle.type.key;

    if (type == '64-premium') code = 'MKSV1D022CL';
    if (type == '77-premium') code = 'MKSV1D025CL';
    if (type == '64-xpower') code = 'MKSV1G027CL';

    return code;
}

export function getMg4UrbanEv2026Code(vehicle) {
    let code = '';

    const type = vehicle.type.key;

    if (type == '43-comfort') code = 'MKSL1C0A4CC';
    if (type == '54-comfort') code = 'MKSL1C0AGCC';
    if (type == '54-premium') code = 'MKSL1D0AMCC';

    return code;
}

export function getMg3Code(vehicle) {
    let code = '';

    const type = vehicle.type.key;
    if (type == 'standard') code = 'MJSBFT1H1LL';
    if (type == 'comfort') code = 'MJSBFC1H1LL';
    if (type == 'luxury') code = 'MJSBFD1H1LL';

    return code;
}

export function getMgZsHevCode(vehicle) {
    let code = '';

    const mgZsHevType = vehicle.type.key;
    if (mgZsHevType == 'standard') code = 'MDSW1T01PLL';
    if (mgZsHevType == 'comfort') code = 'MDSW1D01RLL';
    if (mgZsHevType == 'luxury') code = 'MDSW1G01TLL';

    return code;
}

export function getMgs5Code(vehicle) {
    let code = '';

    const type = vehicle.type.key;
    const versionKey = vehicle.version.key;
    if (versionKey == 'long-range') {
        if (type == 'comfort') code = 'MJR81C00KCL';
        if (type == 'luxury') code = 'MJR81D00QCL';
    }
    if (versionKey == 'standard-range') {
        if (type == 'comfort') code = 'MJR81C00FCL';
    }

    return code;
}

export function getMgZsHybridPlusCode(vehicle) {
    let code = '';

    const type = vehicle.type.key;
    if (type == 'standard') code = 'MDSW1T01PLL';
    if (type == 'comfort') code = 'MDSW1D01RLL';
    if (type == 'luxury') code = 'MDSW1G01TLL';

    return code;
}

export function getMgs6Code(vehicle) {
    let code = '';

    const type = vehicle.type.key;
    const hasBeige =
        vehicle.options && vehicle.options['light-interior']?.selected;

    if (type == 'luxury-rwd') code = hasBeige ? 'MHR91D004CD' : 'MHR91D004CC';
    if (type == 'luxury-awd') code = hasBeige ? 'MHR91F005CD' : 'MHR91F005CC';

    return code;
}

export function getMgs9Code(vehicle) {
    let code = '';

    const type = vehicle.type.key;
    const hasBeigeInterior =
        vehicle.options && vehicle.options['brown-interior']?.selected;

    if (type === 'comfort') {
        code = 'MHSE1D002LL';
    }
    if (type === 'premium') {
        code = hasBeigeInterior ? 'MHSE1G007LN' : 'MHSE1G006LL';
    }
    return code;
}
